import { IconLayoutGrid, IconListDetails } from "@tabler/icons-react";
import { useContext } from "react";
import { CompactContext } from "../../context/context.compact";

const CompactToggle = ({
  className,
  listText,
  cardText,
}: {
  className: string;
  listText: string;
  cardText: string;
}) => {
  const { toggleCompact, compact } = useContext(CompactContext);

  return (
    <button onClick={toggleCompact} className={className}>
      <label className={`swap swap-rotate ${compact && "swap-active"}`}>
        <IconListDetails className="swap-on size-4" />
        <IconLayoutGrid className="swap-off size-4" />
      </label>
      <label className={`swap ${compact && "swap-active"}`}>
        <p className="swap-on">{listText}</p>
        <p className="swap-off">{cardText}</p>
      </label>
    </button>
  );
};
export default CompactToggle;
